import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListEducationLevel = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_EDUCATION_LEVEL'})
}

export const unmountDetailEducationLevel = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_EDUCATION_LEVEL'})
}

export const unmountMasterEducationLevel = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_EDUCATION_LEVEL'})
}

export const listEducationLevel = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_EDUCATION_LEVEL' })
  return API.GET('/education-level/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_EDUCATION_LEVEL_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_EDUCATION_LEVEL_FAILED' }), 
    ))
  })
}

export const detailEducationLevel = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_EDUCATION_LEVEL' })
  const params = {
    'id': id
  }
  API.GET('/education-level/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_EDUCATION_LEVEL_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_EDUCATION_LEVEL_FAILED' }), 
      ))
    )
  })
}

export const masterEducationLevel = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL' })
  return API.GET('/education-level/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL_FAILED' }), 
    ))
  })
}

export const createEducationLevel = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/education-level/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editEducationLevel = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/education-level/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableEducationLevel = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/education-level/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableEducationLevel = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/education-level/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}